import { TModerationStatusOption } from '@api/responseModels/moderation/moderationStatusResponse';
import { RequestResult } from '@api/responseModels/requestResult';

import { CRMAPIBase } from '../crmApiBase';

class ModerationGroup extends CRMAPIBase {
    async getAdminModerationStatuses(): Promise<RequestResult<TModerationStatusOption[]>> {
        const result = await this.get<TModerationStatusOption[]>('/admin/moderation-statuses');
        return result;
    }
}

export { ModerationGroup };
